module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_sola@3x-c3febb9fd198d5ce8a361ea3038cc4e3.webp";